
























import Vue from 'vue'
import { captureException } from '@sentry/browser'
import ModalSimple from '@/common/components/ModalSimple.vue'
import UploadImage from '@/common/components/modalUploadImage/UploadImage.vue'
import Loading from '@/common/components/modalUploadImage/Loading.vue'
import UploadError from '@/common/components/modalUploadImage/UploadError.vue'
import {
  AddImageStates,
  ERROR_CONTENTS,
  LoadingMessages,
  SELF_ABORT_ERROR
} from '@/common/constants/imageUpload'
import { uploadUserDesign } from '@/stockLibrary/services'

export default Vue.extend({
  components: {
    ModalSimple,
    UploadImage,
    Loading,
    UploadError
  },
  props: {
    keepLoadingState: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    addImageState: string
    abortController?: AbortController
  } {
    return {
      addImageState: AddImageStates.IDLE,
      abortController: undefined
    }
  },
  computed: {
    idle(): boolean {
      return this.addImageState === AddImageStates.IDLE
    },
    isModalCloseable(): boolean {
      return this.addImageState !== AddImageStates.GENERATING_PREVIEW
    },
    loading(): boolean {
      return [
        AddImageStates.PROCESSING_FILE,
        AddImageStates.GENERATING_PREVIEW
      ].includes(this.addImageState as AddImageStates)
    },
    loadingMessage(): string {
      return LoadingMessages[this.addImageState as keyof typeof LoadingMessages]
    }
  },
  methods: {
    closeModalHandler() {
      this.$emit('close')
      this.abortController?.abort()
    },
    updateAddImageState(newState: AddImageStates) {
      this.addImageState = newState
    },
    onSelectImage({ file, fileExtension }: { file: File, isSupportTransparent?: boolean, fileExtension: string }) {
      this.uploadImage(file, fileExtension)
    },
    async uploadImage(file: File, fileExtension: string) {
      this.updateAddImageState(AddImageStates.PROCESSING_FILE)
      try {
        this.abortController = new AbortController()
        const postApiPayload = new FormData()
        postApiPayload.append('image', file as string | Blob)
        const { userUploadImageUuids, errors } = await uploadUserDesign(
          { file },
          this.abortController.signal
        ).finally(() => {
          this.abortController = undefined
        })
        if (errors.length > 0) throw errors
        this.$emit('uploadSuccess', {
          uuids: userUploadImageUuids,
          fileExtension
        })
        this.updateAddImageState(AddImageStates.GENERATING_PREVIEW)
        if (!this.keepLoadingState) {
          this.updateAddImageState(AddImageStates.IDLE)
          this.closeModalHandler()
        }
      } catch (errors: any) {
        if (errors.toString().includes(SELF_ABORT_ERROR)) {
          // users abort uploading image by themselves
          this.updateAddImageState(AddImageStates.IDLE)
          return
        }
        const errorCode: string | undefined = errors ? errors[0] : undefined
        if (errorCode) {
          const errorState = ERROR_CONTENTS[errorCode]?.errorState
          const handleErrors =
            errorState &&
            errorState !== AddImageStates.UPLOAD_FAILED_BAD_FILE &&
            errorState !== AddImageStates.PROCESSING_FAILED_BAD_FILE
          if (handleErrors) {
            this.updateAddImageState(
              AddImageStates[errorState as keyof typeof AddImageStates]
            )
            return
          }
        }
        this.updateAddImageState(AddImageStates.PROCESSING_FAILED_UNKNOWN)
        captureException(errors)
      }
    }
  }
})
